
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 10.601l-7.301-7.3a.989.989 0 00-1.398 1.398l7.3 7.301-7.3 7.301a.989.989 0 001.398 1.398l7.301-7.3 7.301 7.3a.989.989 0 001.398-1.398L13.399 12l7.3-7.301a.989.989 0 00-1.398-1.398L12 10.601z"}})])
          )
        }
      }
    